import { DropdownMenuItem } from "@ui-kit/Dropdown";
import type { ComponentProps } from "react";
import type { ConfirmOptions } from "./ConfirmPopoverContent";
import { useMenuConfirm } from "./useMenuConfirm";

type ConfirmMenuItemProps = Omit<ComponentProps<typeof DropdownMenuItem>, "onSelect"> & {
	confirm?: ConfirmOptions | (() => ConfirmOptions | null);
	onConfirm: () => unknown;
};

export const ConfirmMenuItem = ({ confirm: confirmation, onConfirm, ...props }: ConfirmMenuItemProps) => {
	const confirm = useMenuConfirm();

	const select = async (event: Event) => {
		const options = typeof confirmation === "function" ? confirmation() : confirmation;
		if (options && !(await confirm(event, options))) return;
		await onConfirm();
	};

	return <DropdownMenuItem {...props} onSelect={(event) => void select(event)} />;
};
